module.exports = __webpack_public_path__ + "static/media/logo.8ad9ae6d.png";